<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>This book</i>,</p>
<p class="ded1"><i>in which something most extraordinary happens</i>,</p>
<p class="ded1"><i>is about Brick and Diz Dobie and Lily Rose</i>,</p>
<p class="ded1"><i>and Charlie Pill and Princess</i>—</p>
<p class="ded2"><i>and it is dedicated to all of you</i></p>
<p class="ded2"><i>who understand them</i></p>
<p class="ded2"><i>and feel as they did</i>,</p>
<p class="ded2"><i>and have come to believe that</i></p>
<p class="ded2"><i>practically anything is possible</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?69b7210a